import React, { useState, useEffect } from "react";
import "../../assets/css/ManageModel.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import cancel from '../../assets/img/cancel.png'
import axios from 'axios';
import { Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Select from "react-select";


function ManageVariation() {
    const [search, setSearch] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(50);   
    
    const [showModal, setShowModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [name, setName] = useState("");
    const [modelName, setModelName] = useState("");
    const [modelBrand, setModelBrand] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [brands, setBrands] = useState([])
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [model, setModel] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const handleAddModel = async (e) => {
        e.preventDefault();
        setSubmitted(true);
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;
        // Validate form before proceeding
        if (!modelBrand) {
            toast.error("Please select a model");
            return;
        }
        if (!name.trim()) {
            toast.error("Please enter a model variations");
            return;
        }

        const payload = {
            id: isEditMode ? editId : undefined,
            name: name.trim(),  // Trim spaces
            model_id: modelBrand
        };

        console.log('Payload:', payload);

        try {
            const response = await axios({
                method: "POST",
                url: isEditMode
                    ? "https://devapi.bykit.in/api/admin/model-variations/update??type=live"
                    : "https://devapi.bykit.in/api/admin/model-variations/add??type=live",
                data: payload,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log('Response:', response);

            if (response.data?.status === "RC200") {
                toast.success(isEditMode ? "Model Variations updated successfully!" : "Model Variations added successfully!");

                // Reset form
                setModelBrand("");
                setName("");
                setSubmitted(false);
                setIsModalOpen(false);
                getAdminData(); // Refresh list
            } else {
                toast.error(response.data?.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding model:", error);
            toast.error("Failed to save model. Please try again.");
        }
    };

    // Open modal for adding a new variation
    const handleOpenModal = () => {
        setIsEditMode(false);
        setName("");
        setModelBrand("");
        setIsModalOpen(true);
    };

    // Open modal for editing an existing variation
    const handleEditClick = (row) => {
        setIsEditMode(true);
        setEditId(row.id);
        setName(row.name);
        setModelBrand(row.model_id);
        setIsModalOpen(true);
    };
    const getAdminData = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/model-variations??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('managevariation', response)

            if (response.data && response.data.data) {
                setBrands(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        getAdminData();
        getbrandData();
    }, [page, rowsPerPage]);
    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowModal(true);
    };
    const confirmDelete = async () => {
        if (!deleteId) return;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/model-variations/delete/${deleteId}??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Model Variations deleted successfully", { position: "top-right" });
                setBrands((prevBrands) => prevBrands.filter((brand) => brand.id !== deleteId));
            } else {
                toast.error("Failed to delete the Model Variations.", { position: "top-right" });
            }
        } catch (error) {
            console.error("Error deleting brand:", error);
            toast.error("An error occurred while deleting the brand.", { position: "top-right" });
        }

        setShowModal(false);
        setDeleteId(null);
    };

    const columns = [
        { name: "Date", selector: (row) => row.date || "N/A", sortable: true },
        { name: "Brand Name", selector: (row) => row.brand_name || "N/A", sortable: true },
        { name: "Model Name", selector: (row) => row.model_name || "N/A", sortable: true },
        { name: "Name", selector: (row) => row.name || "N/A", sortable: true },

        {
            name: "Action",
            width: "260px",
            cell: (row) => (
                <div className="d-flex justify-content-end">
                    <button className="edit-btn me-2" onClick={() => handleEditClick(row)}>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--heroicons me-1" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path></svg>
                        Edit</button>
                    <button className="delete-btn" onClick={() => handleDeleteClick(row.id)}>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--heroicons me-1" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0"></path></svg>
                        Delete</button>
                </div>

            ),
        },
    ];

    const handlePageChange = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (newRows) => {
        setRowsPerPage(newRows);
        setPage(1);
    };
    const getbrandData = async () => {

        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token

        // const token = localStorage.getItem("token");
        console.log("Token: ?????", token);

        try {
            const response = await axios.get(
                'https://devapi.bykit.in/api/admin/models?page=1&search=&?type=live',
                {
                    method: 'post',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

            console.log("get model name Response:", response);

            if (response.data && response.data.data) {
                setModel(response.data.data || []);


            } else {
                alert('Invalid credentials, please try again.');
            }
        } catch (error) {
            console.error('Error during login:', error);
        }
    };
    const filteredOptions = model?.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const modelOptions = model?.map((item) => ({
        value: item.id,
        label: item.name,
    }));


    return (
        <div className="p-3">
            <ToastContainer />
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Manage Model Variations</p>
            </div>

            <div className="managebrand_box mt-3 mb-2 py-4">
                <div className="d-flex justify-content-between mb-3">
                    <h4 className="dashboard_head ps-3">Manage Model Variations</h4>
                    <button
                        className="add_model_btn me-3"
                        onClick={() => handleOpenModal()}
                    >
                        + Add Variations
                    </button>
                </div>
                <hr />

                <div className='d-flex justify-content-between mt-3 px-3'>
                    <div className="d-flex">
                        <input
                            type="text"
                            placeholder="Search keyword"
                            className="search-input me-2"
                            style={{ padding: '8px' }}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={brands.filter((item) => item.name && item.name.toLowerCase().includes(search.toLowerCase()))}
                    pagination
                    responsive
                    // paginationServer
                    //paginationTotalRows={totalRows}
                    paginationPerPage={rowsPerPage}
                    paginationRowsPerPageOptions={[50,100, 200, 300, 400]}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    customStyles={{
                        headRow: {
                            style: {
                                backgroundColor: "#E2E8F0",
                                color: "#475569",
                                fontWeight: "600",
                            }
                        },
                        pagination: {
                            style: {
                                borderTop: "1px solid #ddd",
                                padding: "10px",
                                backgroundColor: "#f8f9fa"
                            }
                        },
                        cells: {
                            style: {
                                padding: "10px",
                                margin: "0",
                                fontSize: "16px",
                                color: "rgb(71, 85, 105);",
                            },
                        },
                        headCells: {
                            style: {
                                margin: "0",
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "rgb(71, 85, 105);",
                            },
                        },
                    }}
                />
            </div>

            {isModalOpen && (
                <div className="modal fade show d-block" id="addModelModal">
                    <div className="modal-dialog modal_width">
                        <div className="modal-content">
                            <div className="modal-header bg-dark text-white">
                                <h5 className="modal-title">
                                    {isEditMode ? "Edit Model Variations" : "Add Model Variations"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => setIsModalOpen(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleAddModel}>
                                    <div className="mb-3">
                                        <label className="form-label">Model</label>

                                        {/* <select
                                            className={`form-control form-select ${submitted && !modelBrand ? "is-invalid" : ""}`}
                                            value={modelBrand}
                                            onChange={(e) => setModelBrand(e.target.value)}

                                        >
                                            <option value="">Select a model</option>
                                            {filteredOptions?.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select> */}


                                        <div>
                                            <Select
                                                className={`${submitted && !modelBrand ? "is-invalid" : ""}`}
                                                options={modelOptions}
                                                value={modelOptions?.find(option => option.value === modelBrand)}
                                                onChange={(selectedOption) => setModelBrand(selectedOption?.value || "")}
                                                placeholder="Select a model"
                                                isClearable={true} // Allows clearing selection
                                                isSearchable={true} // Enables search
                                            />
                                            {submitted && !modelBrand && <div className="invalid-feedback">Please select a model.</div>}
                                        </div>


                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className={`form-control ${submitted && !name.trim() ? "is-invalid" : ""}`}
                                            placeholder="Enter Model Variations"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>

                                    <div className="d-flex justify-content-end">
                                        <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                                            <span>Submit</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModal && (
                <div className="modal-overlay delete-overlay">
                    <div className="modal-content delete-content">
                        <div className="modal-header bg-dark text-white mt-0">
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className='p-3'>
                            <p className='delete_text'>Are you sure, do you want to delete?</p>
                        </div>
                        <hr className='p-0 m-0'></hr>
                        <div className="modal-buttons text-end p-3">
                            <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
                            <button onClick={confirmDelete} className='model_dlt_btn'>Yes</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
export default ManageVariation;